import _get from 'lodash/get';
import { parseSampleInput, buildSamples, randomSampleInput } from '../event-samples';

// The emulator rejects differential pressure events with more than 30 samples
const MAX_SAMPLES = 30;
const DECIMALS = 2;

const toPascalSample = ({ value, sampleTime }) => ({ pascal: value, sampleTime });

/* @ngInject */
export default class EmulatorDifferentialPressureController {
    constructor(
        EventEmitter
    ) {
        this.EventEmitter = EventEmitter;
    }

    $onInit() {
        this.value = _get(this.device, 'reported.differentialPressure.samples.0.pascal', 0)

        this.inputSamplesText = ''
        this.samples = []
        this.previewVisible = false
        this.shouldIncludeSamples = false
    }

    updateSamples() {
        if (this.value == null) {
            return
        }

        const { sanitisedInput, samples } = parseSampleInput(this.inputSamplesText, this.value, MAX_SAMPLES, DECIMALS)
        this.inputSamplesText = sanitisedInput
        this.samples = samples

        const { samples: output, formattedSampleInterval } = buildSamples(samples, { useDummyTimestamps: true })
        this.formattedSampleInterval = formattedSampleInterval

        this.outputJSON = JSON.stringify({ differentialPressure: { updateTime: output[0].sampleTime, samples: output.map(toPascalSample) } }, null, 4)
    }

    addRandomSamples(count) { // Populates the comma separated input field with a specific number of values (centered around event value)
        this.inputSamplesText = randomSampleInput(count, this.value, DECIMALS)
        this.updateSamples()
    }

    toggleEventPreview() {
        this.previewVisible = !this.previewVisible
    }

    sendEvent() {
        if (this.value == null) {
            return
        }

        // The event only carries samples, so the event value is always the newest one
        const sampleValues = this.shouldIncludeSamples && this.samples.length > 0 ? this.samples : [this.value.toFixed(DECIMALS)]
        const { samples } = buildSamples(sampleValues)

        this.onPublishEvent(
            this.EventEmitter({
                event: {
                    differentialPressure: {
                        // Ensure timestamp of event and first sample is equal
                        updateTime: samples[0].sampleTime,
                        samples: samples.map(toPascalSample)
                    }
                }
            })
        )
    }
}
